import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LivetvlistEntity } from '../livetvlist/livetvlist.entity';
import { LivetvlistController } from './livetvlist.controller';
import { LivetvlistService } from './livetvlist.service';




@Module({
    imports: [
        TypeOrmModule.forFeature([LivetvlistEntity])
    ],
    controllers:[LivetvlistController],
    providers:[LivetvlistService],
    exports:[LivetvlistService],
})
export class LivetvlistModule {}